import { all } from 'redux-saga/effects';
import entriesSagas from '../entries/sagas';

export default function* rootSaga() {
    yield all([...entriesSagas].map(saga => saga()));
};